export default "/img/AG.faa6f845368678f7f8d0d98011416fba.png";